import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_5 = { class: "flex justify-between items-center mb-4" }
const _hoisted_6 = { class: "flex items-center justify-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg" }, " Group email send recipients ", -1)
const _hoisted_8 = { class: "bg-gray-100 rounded-full text-xs block w-6 h-6 ml-2 text-center leading-6" }
const _hoisted_9 = { class: "border rounded-md" }
const _hoisted_10 = {
  class: "overflow-scroll divide-y",
  style: {"max-height":"320px"}
}
const _hoisted_11 = { class: "w-1/3 flex items-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "text-sm cursor-pointer" }
const _hoisted_14 = { class: "w-1/3" }
const _hoisted_15 = { class: "text-sm text-sky font-medium cursor-pointer" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "w-1/3 flex justify-end" }
const _hoisted_18 = { class: "mt-6" }
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full p-6",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendEmails && _ctx.sendEmails(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.bulkSendList.length), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('ModalBulkEmailSend')))
            }, [
              _createVNode(_component_XIcon, { class: "w-5 h-5" })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipients, (recipient) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex items-center justify-start p-4",
                  key: recipient.id
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    (recipient.lender.logoUri)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: recipient.lender.logoUri,
                          class: "mr-2"
                        }, null, 8, _hoisted_12))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(recipient.lender.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(recipient.originator.name), 1),
                    _createElementVNode("a", {
                      href: `mailto:${recipient.originator.email}`,
                      class: "text-sm block text-gray-700"
                    }, _toDisplayString(recipient.originator.email), 9, _hoisted_16)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_router_link, {
                      to: `/originator/${recipient.originator.id}`,
                      class: "border hover:border-gray-400 bg-white rounded-md text-sm px-3 py-1.5 mr-2 flex items-center",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Details ")
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              type: "submit",
              class: _normalizeClass(["bg-sky text-white text-sm px-4 py-2 rounded-md", { 'opacity-50 pointer-events-none': _ctx.loading }]),
              disabled: _ctx.loading
            }, " Confirm ", 10, _hoisted_19)
          ])
        ], 32)
      ])
    ])
  ]))
}